// Schedule › To schedule in Blueprint (BL-189): the model's state words as RowList's tones, and the
// page's lists' states as ListPage's.
import type { RowTone } from '@flowology/ui-web/fl';
import type { ListStatus } from '@flowology/ui-web/patterns';

/** The model's chip tones (tobook-model.ts): warn waits on someone, bad a problem; the rest are muted. */
export function rowTone(tone: string): RowTone {
  return tone === 'warn' ? 'wait' : tone === 'bad' ? 'bad' : 'muted';
}

/** A list's state: loading until it comes, then empty or ready; failed when it didn't come. */
export function listStatus(rows: readonly unknown[] | null, error: string | null): ListStatus {
  return rows ? (rows.length ? 'ready' : 'empty') : error ? 'failed' : 'loading';
}
